import BranchClaimPanel from "./branchClaimPanel.container";

export default BranchClaimPanel;
